import { List } from 'immutable';

// Configuration selector - can be overridden via plugin config
export const selectBackendBaseUrl = (state, props) => {
  // Try to get from props/config first, then fall back to environment variable or default
  const configUrl = props?.backendBaseUrl;
  if (configUrl) return configUrl;

  // Use environment variable or default to relative path
  return process.env.REACT_APP_BACKEND_URL || '/api';
};

export const selectSpecsList = (state) => {
  const list = state.get('specsList');
  return list ? list.toJS() : [];
};

export const selectSpecsListLoading = (state) => state.get('specsListLoading') || false;

export const selectSpecsListError = (state) => state.get('specsListError') || null;

export const selectSelectedSpec = (state) => {
  const spec = state.get('selectedSpec');
  return spec ? spec.toJS() : null;
};

export const selectSpecDetailsLoading = (state) => state.get('specDetailsLoading') || false;

export const selectSpecDetailsError = (state) => state.get('specDetailsError') || null;

export const selectCurrentSpec = (state) => {
  const spec = state.get('currentSpec');
  return spec ? spec.toJS() : null;
};

export const selectSaveLoading = (state) => state.get('saveLoading') || false;

export const selectSaveError = (state) => state.get('saveError') || null;

export const selectIsNewSpec = (state) => {
  const currentSpec = state.get('currentSpec');
  return !currentSpec || !currentSpec.get('id');
};

export const selectHealth = (state) => {
  const health = state.get('health');
  return health ? health.toJS() : null;
};

export const selectHealthLoading = (state) => state.get('healthLoading') || false;

export const selectHealthError = (state) => state.get('healthError') || null;

export const selectDeleteLoading = (state) => state.get('deleteLoading') || false;

export const selectDeleteError = (state) => state.get('deleteError') || null;

export const selectEndpointSettingSaving = (state) => state.get('endpointSettingSaving') || false;

export const selectEndpointSettingSaveError = (state) => state.get('endpointSettingSaveError') || null;

export const selectLastSavedEndpointSetting = (state) => {
  const setting = state.get('lastSavedEndpointSetting');
  return setting ? setting.toJS() : null;
};

export const selectUpstreamUpdating = (state) => state.get('upstreamUpdating') || false;

export const selectUpstreamUpdateError = (state) => state.get('upstreamUpdateError') || null;

export const selectGlobalConfig = (state) => {
  const config = state.get('globalConfig');
  return config ? config.toJS() : null;
};

export const selectGlobalConfigLoading = (state) => state.get('globalConfigLoading') || false;

export const selectGlobalConfigError = (state) => state.get('globalConfigError') || null;

export const selectGlobalConfigUpdating = (state) => state.get('globalConfigUpdating') || false;

export const selectGlobalConfigUpdateError = (state) => state.get('globalConfigUpdateError') || null;

// Environment selectors
export const selectEnvironments = (state) => {
  const list = state.get('environments');
  return list ? list.toJS() : [];
};

export const selectEnvironmentsLoading = (state) => state.get('environmentsLoading') || false;

export const selectEnvironmentsError = (state) => state.get('environmentsError') || null;

export const selectActiveEnvironment = (state) => {
  const env = state.get('activeEnvironment');
  return env ? env.toJS() : null;
};

export const selectEnvironmentDetail = (state) => {
  const detail = state.get('environmentDetail');
  return detail ? detail.toJS() : null;
};

export const selectEnvironmentDetailLoading = (state) => state.get('environmentDetailLoading') || false;

export const selectCreateEnvironmentLoading = (state) => state.get('createEnvironmentLoading') || false;

export const selectCreateEnvironmentError = (state) => state.get('createEnvironmentError') || null;

export const selectDeleteEnvironmentLoading = (state) => state.get('deleteEnvironmentLoading') || false;

export const selectDeleteEnvironmentError = (state) => state.get('deleteEnvironmentError') || null;

export const selectEnvSpecSettingUpdating = (state) => state.get('envSpecSettingUpdating') || false;

export const selectEnvSpecSettingError = (state) => state.get('envSpecSettingError') || null;

export const selectEnvEndpointSettingUpdating = (state) => state.get('envEndpointSettingUpdating') || false;

export const selectEnvEndpointSettingError = (state) => state.get('envEndpointSettingError') || null;
